import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Btech_curriculumEle from './Btech_curriculumEle'


function Main() {
    return (
      <>
          <Header/>
        <Breadcrumb title="Home" subtitle="Curriculum"/>
        <Btech_curriculumEle />
      </>
    )
  }
  
  export default Main